(function () {
  "use strict";

  const slider = new Swiper(".mySwiper", {
    pagination: {
      el: ".swiper-pagination",
    },
  });

  function heroSlider() {
    if (document.querySelector('.hero-slider')) {
      const swiper = new Swiper('.hero-slider .swiper', {
        loop: true,
        // pagination: {
        //   el: ".swiper-pagination",
        //   clickable: true
        // },
        navigation: {
          nextEl: '.hero-slider .slider-button-next',
          prevEl: '.hero-slider .slider-button-prev',
        },
      })
    }
  }

  // Hasta Deneyim Slider
  function hastaDeneyimSlider() {
    if (document.querySelector('.hasta-deneyim-slider')) {
      const slider = new Swiper('.hasta-deneyim-slider .swiper', {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        navigation: {
          nextEl: ".hasta-deneyim-slider .slider-button-next",
          prevEl: ".hasta-deneyim-slider .slider-button-prev",
        },
        breakpoints: {
          768: {
            slidesPerView: 2,
          },

        }
      })
    }
  }
  // Hastane ve Klinik Slider
  function hastaneKlinikSlider() {
    if (document.querySelector('.hastane-klinik-slider')) {
      const slider = new Swiper('.hastane-klinik-slider .swiper', {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        navigation: {
          nextEl: ".hastane-klinik-slider .slider-button-next",
          prevEl: ".hastane-klinik-slider .slider-button-prev",
        },
        breakpoints: {
          768: {
            slidesPerView: 2,
          },
          992: {
            slidesPerView: 3,
          },
          1200: {
            slidesPerView: 4,
          },

        }
      })
    }
  }

  // Intl Tel Input
 

  function telefonInput() {
    const input1 = document.querySelector("#phone");
    const input2 = document.querySelector("#modalPhone");
    const input3 = document.querySelector("#altPhone");

      
    var iti = window.intlTelInput(input1, {
  initialCountry: "auto",
  geoIpLookup: callback => {
    fetch("https://ipapi.co/json")
      .then(res => res.json())
      .then(data => callback(data.country_code))
      .catch(() => callback("US"));
  },
  utilsScript: "/assets/js/utils.js", 
});

var itimodal = window.intlTelInput(input2, {
  initialCountry: "auto",
  geoIpLookup: callback => {
    fetch("https://ipapi.co/json")
      .then(res => res.json())
      .then(data => callback(data.country_code))
      .catch(() => callback("US"));
  },
  utilsScript: "/assets/js/utils.js", 
});

var iticontent = window.intlTelInput(input3, {
  initialCountry: "auto",
  geoIpLookup: callback => {
    fetch("https://ipapi.co/json")
      .then(res => res.json())
      .then(data => callback(data.country_code))
      .catch(() => callback("US"));
  },
  utilsScript: "/assets/js/utils.js", 
});


  // Banner Form Tel Değişimde Ülke bilgisinin inputa eklenmesi
  //const country = document.querySelector("#country");

 /* input1.addEventListener('countrychange', function (e) {
    var countryname = iti.getSelectedCountryData().name;
    country.value = countryname.replace(/.+\((.+)\)/, "$1");
  });*/

    // Modal Form Tel Değişimde Ülke bilgisinin inputa eklenmesi
    //const country2 = document.querySelector("#countrymodal");
 
   /* input2.addEventListener('countrychange', function (e) {
      var countryname = itimodal.getSelectedCountryData().name;
      country2.value = countryname.replace(/.+\((.+)\)/, "$1");
    });*/

// Content Form Tel Değişimde Ülke bilgisinin inputa eklenmesi
//const country3 = document.querySelector("#countrycontent");
 
/*input3.addEventListener('countrychange', function (e) {
  var countryname = iticontent.getSelectedCountryData().name;
  country3.value = countryname.replace(/.+\((.+)\)/, "$1");
});*/

    
  }


  // Scroll top Button
  function scrollTop() {
    const btnScrollTop = document.getElementById('scrollTop')
    document.addEventListener('scroll', () => {
      if (window.scrollY > 1000) {
        btnScrollTop.classList.remove('hide-btn');
      } else {
        btnScrollTop.classList.add('hide-btn');
      }
    })

    btnScrollTop.addEventListener('click', () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    })
  }

  // accordion
  if (document.querySelector('.accordion')) {
    function initAcc(elem, option) {
      document.addEventListener('click', function (e) {
        if (!e.target.matches(elem + ' .a-btn')) return;
        else {
          if (!e.target.parentElement.classList.contains('active')) {
            if (option == true) {
              var elementList = document.querySelectorAll(elem + ' .a-container');
              Array.prototype.forEach.call(elementList, function (e) {
                e.classList.remove('active');
              });
            }
            e.target.parentElement.classList.add('active');
          } else {
            e.target.parentElement.classList.remove('active');
          }
        }
      });
    }

    initAcc('.accordion.v1', true);
  }

  // heroSlider()
  telefonInput()
  hastaDeneyimSlider()
  hastaneKlinikSlider()
  // videoSayfaSlider()
  // deneyimSlider()
  // initAcc('.accordion.v1', true);
  // uygulamalarSlider()
  // scrollTop()


})();